import { render, staticRenderFns } from "./ChangeWaybillCommentModal.vue?vue&type=template&id=eaedc2e0&scoped=true"
import script from "./ChangeWaybillCommentModal.vue?vue&type=script&lang=js"
export * from "./ChangeWaybillCommentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaedc2e0",
  null
  
)

export default component.exports